import type { ApprovalCard } from "@typedoc/contracts/connections";

/**
 * What the sample service shows on an approval card. The sample has no Connections API to ask, so
 * the card the live page would read is held here, by the approval's ID. Nothing in it is real.
 */
export const SAMPLE_APPROVAL_ID = "appr_sample_brightline_reminder";

const BODY = [
  "Hello Brightline team,",
  "",
  "Invoice 2231 for $4,180.00 has waited six days and there is no purchase order on file.",
  "Could you send us the PO number so we can release it for payment?",
  "",
  "Thank you,",
  "Marlow & Co. accounts",
].join("\n");

export const SAMPLE_APPROVAL_CARDS: Readonly<Record<string, ApprovalCard>> = {
  [SAMPLE_APPROVAL_ID]: {
    id: SAMPLE_APPROVAL_ID,
    status: "pending",
    revision: 1,
    app: { slug: "gmail", name: "Gmail", logo: "https://logos.composio.dev/api/gmail" },
    account: "Accounts inbox",
    tool: { slug: "GMAIL_SEND_EMAIL", label: "Send email" },
    category: "send",
    sentence: "Gmail wants to send email (Send messages).",
    opaque: false,
    edited: null,
    arguments: {
      recipient_email: "accounts@brightlineprint.example",
      subject: "Purchase order for invoice 2231",
      body: BODY,
      cc: ["maya@marlow.example"],
    },
    fields: [
      {
        key: "recipient_email",
        label: "To",
        kind: "email",
        required: true,
        value: "accounts@brightlineprint.example",
        readOnly: false,
        material: false,
      },
      {
        key: "cc",
        label: "Cc",
        kind: "chips",
        required: false,
        value: ["maya@marlow.example"],
        readOnly: false,
        material: false,
      },
      {
        key: "subject",
        label: "Subject",
        kind: "text",
        required: false,
        value: "Purchase order for invoice 2231",
        readOnly: false,
        material: false,
      },
      {
        key: "body",
        label: "Body",
        kind: "longtext",
        required: false,
        value: BODY,
        readOnly: false,
        material: false,
      },
    ],
  },
};
